import type { RootState } from '../../../store'

export const selectFeature2ChargingSteeringState = (state: RootState) =>
  state.feature2ChargingSteering
export const selectFeature2ChargingSteeringVin = (state: RootState) =>
  state.feature2ChargingSteering.vin
export const selectFeature2CommandLoading = (state: RootState) =>
  state.feature2ChargingSteering.commandLoading
export const selectFeature2StatusLoading = (state: RootState) =>
  state.feature2ChargingSteering.statusLoading
export const selectFeature2VehicleStateLoading = (state: RootState) =>
  state.feature2ChargingSteering.vehicleStateLoading
export const selectFeature2ResumeChargingAtEnabled = (state: RootState) =>
  state.feature2ChargingSteering.resumeChargingAtEnabled
export const selectFeature2ResumeChargingAt = (state: RootState) =>
  state.feature2ChargingSteering.resumeChargingAt
export const selectFeature2CommandIdInput = (state: RootState) =>
  state.feature2ChargingSteering.commandIdInput
export const selectFeature2LastCommandId = (state: RootState) =>
  state.feature2ChargingSteering.lastCommandId
export const selectFeature2LastCommandAction = (state: RootState) =>
  state.feature2ChargingSteering.lastCommandAction
export const selectFeature2CommandResponse = (state: RootState) =>
  state.feature2ChargingSteering.commandResponse
export const selectFeature2CommandStatusResponse = (state: RootState) =>
  state.feature2ChargingSteering.commandStatusResponse
export const selectFeature2VehicleStateResponse = (state: RootState) =>
  state.feature2ChargingSteering.vehicleStateResponse
export const selectFeature2CommandError = (state: RootState) =>
  state.feature2ChargingSteering.commandError
export const selectFeature2StatusError = (state: RootState) =>
  state.feature2ChargingSteering.statusError
export const selectFeature2VehicleStateError = (state: RootState) =>
  state.feature2ChargingSteering.vehicleStateError
